module.exports = __webpack_public_path__ + "static/Ricardas_Skorupskas-e9b118f1fcbce1a29485f46e3b0ab03a.jpg";